import { AfterViewInit, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { BlogSwiperComponent } from '../../components/blog-swiper/blog-swiper.component';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { StatisticsDto } from '../../../dtos/statistics.dto';
import { StatisticsService } from '../../../services/statistics.service';
import { RouterLink } from '@angular/router';
import { CreatureLiteWebDto } from '../../../dtos/creature.lite.web.dto';
import { RarityType } from '../../../enums/rarity.type';
import { CreatureType } from '../../../enums/creature.type';
import { RarityNamePipe } from '../../../pipes/rarity-name.pipe';
import { CreatureTypePipe } from '../../../pipes/creature-type.pipe';
import { EthPricePipe } from '../../../pipes/eth-price.pipe';
import { TimeAgoPipe } from '../../../pipes/time-ago.pipe';
import { CreaturesService } from '../../../services/creatures.service';
import { CreatureSortType } from '../../../enums/creature-sort.type';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { InfoSalesComponent } from '../../components/info-sales/info-sales.component';

@Component({
  selector: 'index-page',
  templateUrl: './index.page.html',
  styleUrl: './index.page.scss',
  imports: [
    CommonModule,
    RouterLink,
    BlogSwiperComponent,
    InfoSalesComponent,
    RarityNamePipe,
    CreatureTypePipe,
    EthPricePipe,
    TimeAgoPipe,
    TranslateModule,
    FormsModule
  ],
})
export class IndexPage implements OnInit {

  public readonly creatureType: typeof CreatureType = CreatureType;
  public readonly rarityType: typeof RarityType = RarityType;

  public lang: string | null = null;

  statistics: StatisticsDto | null = null;
  staticFilter: '24h' | '7d' | '30d' = '24h';

  recentListed: CreatureLiteWebDto[] = [];
  discoverCreatures: CreatureLiteWebDto[] = [];

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private readonly statisticsService: StatisticsService,
    private readonly creaturesService: CreaturesService,
    private readonly translateService: TranslateService,
  ) {
    this.lang = this.translateService.currentLang;
    this.translateService.onLangChange.subscribe((event) => {
      this.lang = event.lang;
    })
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.statisticsService.getStatistics().subscribe({
        next: (data) => {
          this.statistics = data;
        },
        error: (err) => {
          console.error('Failed to load statistics:', err);
        },
      });

      this.statisticsService.getRecentListedCreatures().subscribe({
        next: (data) => {
          this.recentListed = data;
        },
        error: (err) => {
          console.error('Failed to load recent listed creatures:', err);
        },
      });

      this.creaturesService.getByFilter({
        page: 0,
        pageSize: 12,
        availableForBreeding: null,
        sortBy: CreatureSortType.LevelDesc,
        onlyMy: false,
        onlyForTrade: true,
        minHp: null,
        maxHp: null,
        minLevel: null,
        maxLevel: null,
        minPrice: null,
        maxPrice: null,
        isChildren: false,
        isParent: false,
        abilityIds: [],
        types: [],
        rarities: [],
        ignoreIds: [],
        nftTokenIds: [],
        nftParentTokenId: null
      }).subscribe({
        next: (data) => {
          this.discoverCreatures = data;
        },
        error: (err) => {
          console.error('Failed to load discover creatures:', err);
        },
      });
    }
  }
}
